module.exports = __webpack_public_path__ + "pdf/decor.22fd5f5.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pdf/decor.pdf
// module id = gKV+
// module chunks = 0